import { render, staticRenderFns } from "./UserRoleDetailView.vue?vue&type=template&id=73d86e7a&scoped=true&"
import script from "./UserRoleDetailView.vue?vue&type=script&lang=ts&"
export * from "./UserRoleDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d86e7a",
  null
  
)

export default component.exports